export function Required(target: any, propertyKey: string) {
	if (!target.constructor.requiredProperties) {
	  	target.constructor.requiredProperties = [];
	}
	target.constructor.requiredProperties.push(propertyKey);
}